
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

import { constants } from 'src/app/shared/common/contants';
import { CommonService } from 'src/app/shared/services/common.service';
import { ExceljsServiceService } from 'src/app/shared/services/exceljs-service.service';

@Component({
    selector: 'app-create-attributes-popup',
    templateUrl: './create-attributes-popup.component.html',
    styleUrls: ['./create-attributes-popup.component.scss'],
    standalone: false
})
export class CreateAttributesPopupComponent implements OnInit {

  validations_form: UntypedFormGroup;

  columnDefs;
  defaultColDef;
  buttonColor = "";
  backgroundColorScreen;
  gridApi;
  components: any;
  paginationPageSize;
  paginationNumberFormatter;
  recordList: any[] = [];
  rowClassRules;
  onEditButton = false;
typeList: any[] = [];
  recordHeaders = ["Field", "Type", "Type Value", "Null", "Key", "Default", "Extra"];
  recordObject = {
    index: 0,
    field: null,
    type: null,
    typeValue: null,
    nullValue: null,
    key: null,
    default: null,
    extra: null
  }
  pagesize: any;
  lastpage: any;
  currentpage: any;
  nextpage: any;
  nextpageplusone: any;
  totalpages: any;

  constructor(
    public dialogRef: MatDialogRef<CreateAttributesPopupComponent>, private validation: validationmethod, private snackbar: MatSnackBar, private commonService: CommonService,
    private constants: constants, private localStorageSettings: LocalStorageSettingsService, @Inject(MAT_DIALOG_DATA) public data: any, private excelService: ExceljsServiceService
  ) {
    this.components = {
      buttonRenderer: Actionbutton,
    }
  }

  ngOnInit(): void {

    this.formValidation();
    this.loadTypeDropdown();

    if (this.data?.existingAttributesData) {

      const existingData = JSON.parse(this.data.existingAttributesData);

      this.recordList = existingData.map((item, index) => {

        return {
          index: index,
          field: item.Field,
          type: item.Type?.split("(")[0]?.toUpperCase(),
          typeValue: item.Type?.includes("(") ? item.Type.split("(")[1].replace(")", "") : "",
          nullValue: item.Null === "YES" ? "Yes" : "No",
          key: item.Key,
          default: item.Default,
          extra: item.Extra
        }

      });

    }
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };
    this.columnDefs = [
      {
        headerName: 'Action',
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          edit: this.editIcon.bind(this),
          delete: this.deleteIcon.bind(this)
        },
        width: 120
      },
      { headerName: 'Field', headerTooltip: 'Field', tooltipValueGetter: (params) => 'Field : ' + params.value, field: 'field', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Type', headerTooltip: 'Type', tooltipValueGetter: (params) => 'Type : ' + params.value, field: 'type', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Type Value', headerTooltip: 'Type Value', tooltipValueGetter: (params) => 'Type Value : ' + params.value, field: 'typeValue', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Null', headerTooltip: 'Null', tooltipValueGetter: (params) => 'Null : ' + params.value, field: 'nullValue', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Key', headerTooltip: 'Key', tooltipValueGetter: (params) => 'Key : ' + params.value, field: 'key', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Default', headerTooltip: 'Default', tooltipValueGetter: (params) => 'Default : ' + params.value, field: 'default', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Extra', headerTooltip: 'Extra', tooltipValueGetter: (params) => 'Extra : ' + params.value, field: 'extra', filter: 'agTextColumnFilter', width: 150 }
    ];

    this.rowClassRules = {
      "sick": function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },

    };

    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    }
  }

  formValidation() {
    this.validations_form = new UntypedFormGroup({
      field: new UntypedFormControl('', Validators.required),
      type: new UntypedFormControl(''),
      typeValue: new UntypedFormControl(''),
      nullValue: new UntypedFormControl(''),
      key: new UntypedFormControl(''),
      default: new UntypedFormControl(''),
      extra: new UntypedFormControl('')
    });
  }

  onBtExport() {
    const columnKeys = this.columnDefs
    .filter(col => col.field) 
    .map(col => col.field);

  this.gridApi.api.exportDataAsCsv({
    columnKeys: columnKeys
  });
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridApi.api) {
      this.lastpage = this.gridApi.api.paginationIsLastPageFound();
      this.currentpage = this.gridApi.api.paginationGetCurrentPage() + 1
      this.nextpage = this.gridApi.api.paginationGetCurrentPage() + 1 + 1
      this.nextpageplusone = this.gridApi.api.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalpages = this.gridApi.api.paginationGetTotalPages()
    }
  }
  //this function is for going to the given page number 
  onSearchChange(searchValue: number) {

    this.gridApi.api.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {
    var value = this.pagesize
    this.gridApi.api.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridApi.api.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridApi.api.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    console.log("first")
    this.gridApi.api.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    console.log("last")
    this.gridApi.api.paginationGoToLastPage();
  }

  onGridReady(params) {
    this.gridApi = params;
    params.api.setGridOption('rowData', [])
    this.gridApi.api.setGridOption('rowData', this.recordList);
  }

  saveAttributes() {
    const attributesJsonData = this.recordList.map(item => {

      return {
        "Key": item.key ? item.key : "",
        "Null": item.nullValue === "Yes" ? "YES" : "NO",
        "Type": item.typeValue ? `${item.type.toLowerCase()}(${item.typeValue})` : item.type?.toLowerCase(),
        "Extra": item.extra ? item.extra : "",
        "Field": item.field,
        "Default": item.default ? item.default : null
      }

    });

    let attributesStringData = JSON.stringify(attributesJsonData);
    console.log(attributesStringData);
    this.dialogRef.close(attributesStringData);
  }


  loadTypeDropdown(){
  this.commonService.getAttributeTypes().subscribe((res:any)=>{
    this.typeList = res;
  });
}

  editIcon(e) {

    this.recordObject = { ...e.rowData };
    this.onEditButton = true;
  }

  deleteIcon(e) {

    this.recordList.splice(e.rowData.index, 1);

    this.recordList.forEach((x, i) => x.index = i);

    this.gridApi.api.setGridOption('rowData', this.recordList);
  }

  async onFileChange(event: any): Promise<void> {
    console.log(event);
    let input = event.target as HTMLInputElement;
    const target: DataTransfer = <DataTransfer>event.target;

    if (target.files.length !== 1) {
      console.error('Cannot use multiple files');
      return;
    }

    // const reader: FileReader = new FileReader();
    // reader.onload = (e: any) => {
    //   const binaryData = e.target.result;
    //   const workbook: XLSX.WorkBook = XLSX.read(binaryData, { type: 'binary' });

    //   // Read the first sheet
    //   const sheetName: string = workbook.SheetNames[0];
    //   const sheet: XLSX.WorkSheet = workbook.Sheets[sheetName];

    //   // Convert to JSON
    //   const jsonData: any = XLSX.utils.sheet_to_json(sheet, { header: 1 });
    //   console.log(jsonData);

    //   if (jsonData.length > 0) {
    //     let headerList = []
    //     headerList = jsonData[0]
    //     let labelsToRemove = this.recordHeaders.map(obj => obj);
    //     headerList = jsonData[0].filter(item => !labelsToRemove.includes(item));
    //     if (headerList.length == 0) {
          
    //       const headers = jsonData[0];

    //       let data = jsonData.slice(1).map((row: any[], i: number) => {
    //         return {
    //           index: this.recordList.length + i,
    //           field: row[headers.indexOf("Field")] || '',
    //           type: row[headers.indexOf("Type")] || '',
    //           typeValue: row[headers.indexOf("Type Value")] || '',
    //           nullValue: row[headers.indexOf("Null")] || '',
    //           key: row[headers.indexOf("Key")] || '',
    //           default: row[headers.indexOf("Default")] || '',
    //           extra: row[headers.indexOf("Extra")] || ''
    //         };
    //       });
    //       // });
    //       console.log(data);
    //       try {
    //         this.validateExcelData(data);
    //         const uniqueData = data.filter((item, index, self) =>
    //           index === self.findIndex(record =>
    //             record.field?.trim() === item.field?.trim()
    //           )
    //         )
    //         console.log(uniqueData)
    //         const finalUniqueData = uniqueData.filter(newRecord =>
    //           !this.recordList.some(existingRecord =>
    //             existingRecord.field?.trim() === newRecord.field?.trim()
    //           )
    //         )
    //         this.recordList.push(...finalUniqueData)
    //         //  this.recordList.push(...data)
    //         this.gridApi.api.setGridOption('rowData', this.recordList)
    //       } catch (error) {
    //         console.error(error.message);
    //         // optionally show error in UI
    //         this.snackbar.open(error.message, "OK", { duration: 5000 });
    //       }

    //     } else {
    //       alert("The headers appear to be mismatched. Kindly update them to match correctly.")
    //     }
    //   }
    // };

    // reader.readAsBinaryString(target.files[0]);
    try {

  const jsonData =
    await this.excelService.readExcelAsMatrix(
      target.files[0]
    );

  console.log(jsonData);

  if (jsonData.length > 0) {

    let headerList: any[] = [];

    headerList = jsonData[0];

    const labelsToRemove =
      this.recordHeaders.map(obj => obj);

    headerList =
      jsonData[0].filter(
        item => !labelsToRemove.includes(item)
      );

    if (headerList.length === 0) {

      const headers = jsonData[0];

      const data = jsonData
        .slice(1)
        .map((row: any[], i: number) => {

          return {
            index: this.recordList.length + i,
            field:
              row[headers.indexOf("Field")] || '',
            type:
              row[headers.indexOf("Type")] || '',
            typeValue:
              row[headers.indexOf("Type Value")] || '',
            nullValue:
              row[headers.indexOf("Null")] || '',
            key:
              row[headers.indexOf("Key")] || '',
            default:
              row[headers.indexOf("Default")] || '',
            extra:
              row[headers.indexOf("Extra")] || ''
          };

        });

      console.log(data);

      try {

        this.validateExcelData(data);

        const uniqueData = data.filter(
          (item, index, self) =>
            index === self.findIndex(
              record =>
                record.field?.trim() ===
                item.field?.trim()
            )
        );

        const finalUniqueData =
          uniqueData.filter(
            newRecord =>
              !this.recordList.some(
                existingRecord =>
                  existingRecord.field?.trim() ===
                  newRecord.field?.trim()
              )
          );

        this.recordList.push(
          ...finalUniqueData
        );

        this.gridApi.api.setGridOption(
          'rowData',
          this.recordList
        );

      } catch (error: any) {

        console.error(error.message);

        this.snackbar.open(
          error.message,
          "OK",
          { duration: 5000 }
        );
      }

    } else {

      alert(
        "The headers appear to be mismatched. Kindly update them to match correctly."
      );

    }

  }

} catch (error) {

  console.error(error);

  this.snackbar.open(
    "Unable to read Excel file",
    "OK",
    { duration: 5000 }
  );

}
    input.value = '';
  }

  validateExcelData(data: any[]): void {

    data.forEach((item, i) => {

      if (!item.field) {
        throw new Error(`Field is required in row`);
      }

    });

  }

  downloadTemplate() {

    console.log('working');
    var data = [{
      "Field": '',
      "Type": '',
      "Type Value": '',
      "Null": '',
      "Key": '',
      "Default": '',
      "Extra": ''
    }];
    this.JSONToCSVConvertor(data, 'AttributeHeadersTemplate', true);
  }

  JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
    //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

    var CSV = '';

    //This condition will generate the Label/Header
    if (ShowLabel) {
      var row = '';

      //This loop will extract the label from 1st index of on array
      for (var index in arrData[0]) {

        //Now convert each value to string and comma-seprated
        row += index + ',';
      }

      row = row.slice(0, -1);

      //append Label row with line break
      CSV += row + '\r\n';
    }

    //1st loop is to extract each row
    for (var i = 0; i < arrData.length; i++) {
      var row = '';

      //2nd loop will extract each column and convert it in string comma-seprated
      for (var index in arrData[i]) {
        row += '"' + arrData[i][index] + '",';
      }
      //add a line break after each row
      CSV += row + '\r\n';
    }

    if (CSV == '') {
      alert('Invalid data');
      return;
    }

    //Generate a file name
    var fileName = '';
    //this will remove the blank-spaces from the title and replace it with an underscore
    fileName += ReportTitle.replace(/ /g, '_');

    //Initialize file format you want csv or xls
    var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

    var link = document.createElement('a');
    link.href = uri;

    //set the visibility hidden so it will not effect on your web-layout
    // @ts-ignore
    link.style = 'visibility:hidden';
    link.download = fileName + '.csv';

    //this part will append the anchor tag and remove it after automatic click
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  resetForm() {

    this.recordObject = {
      index: 0,
      field: null,
      type: null,
      typeValue: null,
      nullValue: null,
      key: null,
      default: null,
      extra: null
    }

    this.onEditButton = false;

    this.validations_form.reset();
  }


  cancel() {
    this.dialogRef.close();
  }

  addWhere() {

    if (!this.validations_form.valid) {

      this.validation.validateAllFormFields(this.validations_form);
      this.validation.getvalidationmessage();
      return;

    }

    const duplicate = this.recordList.some(item =>
      item.field === this.recordObject.field &&
      item.index !== this.recordObject.index
    );

    if (duplicate) {
      this.snackbar.open("Attribute already existed", "Ok", { duration: 5000 })
      return
    }

    if (this.onEditButton) {

      const index = this.recordList.findIndex(x => x.index === this.recordObject.index);
      this.recordList[index] = { ...this.recordObject };

    } else {

      this.recordObject.index = this.recordList.length;
      this.recordList.push({ ...this.recordObject })

    }

    this.gridApi.api.setGridOption('rowData', this.recordList);

    this.resetForm();

  }
}
